import { S_TextNumberValue } from 'elements/minute/sidebar/sidebarComponents/atomic/TextNumberValue/TextNumberValue';
import { EFonts } from 'libs/styles/styling';
import { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    value: number;
    width?: string;
    placeholder?: string;
    label?: string;
    onChange?: (value: number) => void;
    onBlur?: (value: number) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
    className?: string;
}

export const NumberValue = (props: Props): JSX.Element => {
    const [value, setValue] = useState<number | string>(props.value);

    useEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <S_NumberValue className={props.className}>
            <S_Input
                type="number"
                value={value}
                width={props.width}
                placeholder={props.placeholder}
                $hasValue={value !== undefined && value !== null && value !== ''}
                autoComplete="nope"
                onFocus={props.onFocus}
                onChange={(e) => {
                    if (e.target.value === '' || e.target.value === '-') {
                        setValue(e.target.value);
                    } else {
                        setValue(e.target.value);
                        props.onChange?.(Number(e.target.value));
                    }
                }}
                onBlur={() => {
                    props.onBlur?.(Number(value));
                }}
                onKeyDown={(e) => {
                    props.onKeyDown?.(e);
                    e.stopPropagation();
                }}
            />
            {props.label && <S_Label> {props.label}</S_Label>}
        </S_NumberValue>
    );
};

const S_NumberValue = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 80px;
`;

const S_Input = styled(S_TextNumberValue)<{
    $hasValue: boolean;
}>`
    width: 100%;
    text-align: center;
    border-radius: 0;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

const S_Label = styled.div`
    color: #141c54;
    font-size: 13px;
    font-family: ${EFonts.Regular};
    width: 100%;
    text-align: center;
    user-select: none;
    margin: 15px 0 0 0;
`;
